/**
 * Spacing theme values.
 */
import { Spacing } from "@oui/system/spacing"

const spacing: Spacing = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 40
}

export default spacing
